// actions.js
export const INIT_FLUID_HANDLER_LIST_REQUEST = 'INIT_FLUID_HANDLER_LIST_REQUEST';
export const SET_FLUID_HANDLER_LIST = 'SET_FLUID_HANDLER_LIST';
export const ERROR_FLUID_HANDLER_LIST = 'ERROR_FLUID_HANDLER_LIST';

export const INIT_SINGLE_FLUID_HANDLER_REQUEST = 'INIT_SINGLE_FLUID_HANDLER_REQUEST';
export const SET_SINGLE_FLUID_HANDLER = 'SET_SINGLE_FLUID_HANDLER';
export const ERROR_SINGLE_FLUID_HANDLER = 'ERROR_SINGLE_FLUID_HANDLER';

export function initFluidHandlerListRequest() {
  return { type: INIT_FLUID_HANDLER_LIST_REQUEST };
}

export function setFluidHandlerList(data) {
  return { type: SET_FLUID_HANDLER_LIST, payload: data };
}

export function errorFluidHandlerList(error) {
  return { type: ERROR_FLUID_HANDLER_LIST, payload: error };
}

export function initSingleFluidHandlerRequest(id) {
  return { type: INIT_SINGLE_FLUID_HANDLER_REQUEST, payload: id };
}

export function setSingleFluidHandler(data) {
  return { type: SET_SINGLE_FLUID_HANDLER, payload: data };
}

export function errorSingleFluidHandler(error) {
  return { type: ERROR_SINGLE_FLUID_HANDLER, payload: error };
}
